import{createElement as e}from"../../../../external/preact/dist/preact.js";const t=({paymentMethodComponent:t,isLoaded:a})=>t&&a?e("div",{className:"adyen-checkout__payment-method__details__content"},t):null;export{t as default};
//# sourceMappingURL=PaymentMethodDetails.js.map
